import { Component } from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-account-cancellation-successful',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './account-cancellation-successful.component.html',
  styleUrl: './account-cancellation-successful.component.scss'
})
export class AccountCancellationSuccessfulComponent {

}
